import{appEventBus as e}from"../appEventBus.js";import{useEffect as s}from"react";var p=e=>(p,t)=>{s(()=>e.on(p,e=>t(e)),[p,t])},t=p(e);export{p as createUseAppEventBus,t as useAppEventBus};
//# sourceMappingURL=useAppEventBus.js.map